import { apiRequest } from "./apiClient";
export const getAllEmployees = async () => {
  const response = await apiRequest({ method: "GET", endpoint: "/employees" });
  return response.data.map((employee) => ({
    value: employee.id,
    label: employee.name,
  }));
};
